module.exports = __webpack_public_path__ + "img/icon.36699441.png";